import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { usePrefix, useT } from "@/i18n";

const SPANS = [
  "lg:col-span-7",
  "lg:col-span-4 lg:col-start-9 lg:mt-24",
  "lg:col-span-5 lg:col-start-2 lg:mt-16",
  "lg:col-span-4 lg:col-start-8 lg:mt-16",
];

const Work = ({ w, i }) => (
  <motion.figure
    className={`col-span-12 ${SPANS[i]}`}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`work-item-${i + 1}`}
  >
    <div className="frame group">
      <div className="overflow-hidden">
        <img
          src={w.img}
          alt={w.title}
          loading="lazy"
          className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
        />
      </div>
    </div>
    <figcaption className="mt-5 flex flex-col gap-1.5">
      <span className="font-serif text-2xl leading-snug tracking-tight">{w.title}</span>
      <span className="text-xs uppercase tracking-[0.18em] text-smoke">{w.place}</span>
    </figcaption>
  </motion.figure>
);

export const Portfolio = () => {
  const t = useT().portfolio;
  const prefix = usePrefix();

  return (
    <section id="works" className="bg-sand/60" data-testid="portfolio-section">
      <div className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <p className="mb-4 text-[11px] uppercase tracking-[0.35em] text-terra" data-testid="portfolio-kicker">{t.kicker}</p>
          <h2 className="max-w-2xl font-serif text-4xl tracking-tight sm:text-5xl" data-testid="portfolio-heading">
            {t.headingA} <em className="italic text-terra">{t.headingEm}</em>
          </h2>
          <p className="mt-6 max-w-xl text-base text-smoke md:text-lg" data-testid="portfolio-subtext">
            {t.subtext}
          </p>
        </Reveal>

        <div className="mt-20 grid grid-cols-12 gap-x-8 gap-y-16 lg:gap-y-8">
          {t.works.map((w, i) => (
            <Work key={w.img} w={w} i={i} />
          ))}
        </div>

        <Reveal className="mt-20">
          <Link
            to={`${prefix}/galleria`}
            data-testid="portfolio-gallery-link"
            className="group inline-flex items-center gap-3 border border-ink px-8 py-4 text-xs uppercase tracking-[0.22em] transition-colors duration-300 hover:bg-ink hover:text-bone"
          >
            {t.allWorks}
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
